<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    titleDate: {
      type: String,
      default: '',
    },

    titleProject: {
      type: String,
      default: '',
    },
    address:{
      type: String,
      default: 'អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ'
    },
    phone:{
      type: String,
      default: 'ទូរស័ព្ទលេខៈ 092 92 66 88 | 086 62 66 89 Email: account@h-residence.net'
    }
  },
  methods: {

  },
}
</script>

<template>
  <!-- start page title -->
   <table width="100%" class="content-general bottom">
        <tr>
          <td width="9%"><p>&nbsp;</p></td>
          <td width="50%"><p>&nbsp;</p></td>
          <td width="35%"><p>&nbsp;</p></td>
        </tr>
        <tr>
          <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
          <td>
            <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
            <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
            <p class="khs h8">{{address}}</p>
            <p class="khs h8">{{phone}}</p>
          </td>
          <td class="">
              <p class="khb"><u>{{title}}</u></p>
              <p class="khb"><u>{{titleDate}}</u></p>
              <p class="khb"><u>{{titleProject}}</u></p>
          </td>
        </tr>
        
      </table>
  <!-- end page title -->
</template>
